<template>
  <Transition name="slide-up">
    <div
      v-if="isVisible"
      class="bg-background-neutral-secondary toast-shadow absolute rounded-[100px] px-6 py-2"
    >
      <div
        class="flex items-center justify-between space-x-3 text-sm font-semibold"
      >
        <div class="shrink-0">
          <slot name="icon" v-bind="{ content }" />
        </div>
        <div class="grow" role="alert" aria-live="polite">
          <slot v-bind="{ content }" />
        </div>
      </div>
    </div>
  </Transition>
</template>

<script setup lang="ts">
  import { ref, readonly, onBeforeUnmount } from 'vue';

  const props = defineProps({
    duration: {
      type: Number,
      default: 5000,
    },
    persistent: {
      type: Boolean,
      default: false,
    },
  });

  const timeoutId = ref();
  const content = ref();

  const isVisible = ref(false);

  const hide = () => {
    isVisible.value = false;
    if (!props.persistent) {
      clearTimeout(timeoutId.value);
    }
  };

  const show = (alertContent?: unknown) => {
    if (isVisible.value) {
      hide();
    }
    isVisible.value = true;
    content.value = alertContent;
    if (!props.persistent) {
      timeoutId.value = setTimeout(hide, props.duration);
    }
  };

  defineExpose({
    show,
    hide,
    isVisible: readonly(isVisible),
  });

  onBeforeUnmount(hide);
</script>

<style scoped>
  .slide-up-enter-from,
  .slide-up-leave-to {
    transform: translateY(100%);
    opacity: 0;
  }

  .slide-up-enter-to,
  .slide-up-leave-from {
    transform: translateX(0);
    opacity: 1;
  }

  .slide-up-enter-active,
  .slide-up-leave-active {
    transition: all 500ms cubic-bezier(0.24, 0.87, 0.71, 0.98);
  }

  .toast-shadow {
    box-shadow: 0px 5px 20px 0px rgba(0, 0, 0, 0.1);
    backdrop-filter: blur(50px);
  }
</style>
